import { Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { NextArrowIcon } from "src/assets/Icons";
import { explode } from "src/utility";
import { useSSRContext } from "../../context/SSRContext";
import { SSR_OPTIONS } from "src/Modules/Flights/constants";

export default function FlightSelection() {
  const { t } = useTranslation();
  const { flightOptions, cursor, handleChange } = useSSRContext();
  const { ssrType } = cursor;
  const isSegmentSelection = SSR_OPTIONS.find((option) => option.value === ssrType)?.ssrSelectionType === "segment";

  const currentFlight = flightOptions.find((flight) => flight.value === cursor.flightId);
  const tabs = isSegmentSelection ? flightOptions.filter((flight) => flight.flightIndex === 0) : flightOptions;

  if (tabs.length <= 1) return null;

  const isActive = (flight: (typeof tabs)[number]) =>
    isSegmentSelection ? flight.segmentIndex === currentFlight?.segmentIndex : flight.value === cursor.flightId;

  const renderLabel = (flight: (typeof tabs)[number]) => {
    if (isSegmentSelection) return flight.segmentIndex === 0 ? t("Flights.search.departure") : t("Flights.search.return");
    const { origin, destination } = explode(flight, {});
    return (
      <div className="flex items-center gap-2">
        {origin.code}
        <NextArrowIcon className="h-3 w-3" />
        {destination.code}
      </div>
    );
  };

  return (
    <Tabs
      items={tabs.map((flight) => ({ key: flight.value, label: renderLabel(flight) }))}
      activeKey={tabs.find(isActive)?.value}
      onChange={(value) => handleChange("flightId", value)()}
      className="w-full!"
      more={{
        visible: false,
      }}
      classNames={{
        item: "uppercase! font-medium! text-sm! px-2!",
        header: "mb-0!",
      }}
    />
  );
}
